import { useState } from "react";
import { VendedorInfo } from "../../../EmpresaComponents/EditarDealForm";
import { SaveButton } from "../../../UtilitiesComponents/SaveButton";
import { CancelButton } from "../../../UtilitiesComponents/CancelButton";
import { useGetVisitaByIdQuery } from "../../../../api/visitasApi";
import { CircularProgress } from "@mui/joy";
import { ErrorMessage } from "../../../UtilitiesComponents/ErrorMessage";
import { IntencionesVendidas } from "./IntencionesVendidas";
import { AddVendedoresToVisita } from "./AddVendedoresToVisita";
import { VendedoresAsignados } from "./VendedoresAsignados";
import { EditVisitInfoForm } from "./EditVisitInfoForm";
import { VisitDetailsInfo } from "./VisitDetailsInfo";

interface Props {
    visitaId: number;
    disableFinishButton?: boolean
    onFinish?: () => void; 
    onCancel?: () => void; 
}

export function VisitaDetails({ visitaId, onFinish, onCancel, disableFinishButton }: Props) {
    const [vendedoresAgregados, setVendedoresAgregados] = useState<VendedorInfo[]>([])
    const [isAddVendedores, setIsAddVendedores] = useState(false);
    const [isEditVisitInfo, setIsEditVisitInfo] = useState(false);

    const { data: visita, isFetching, isError, isSuccess } = useGetVisitaByIdQuery({ visitaId });

    if(isFetching)
        return (
        <div className="flex justify-center items-center w-full h-full">
            <CircularProgress />
        </div>
    );

    if(isError || !isSuccess)
        return (
        <div className="flex justify-center items-center w-full h-full">
            <ErrorMessage customMessage>
                Ocurrió un problema al cargar la informacion. Intente más tarde.
            </ErrorMessage>
        </div>
    );

    return (
        <div className="flex-1 flex flex-col w-full overflow-hidden">

            <div className="shrink-0">
                {isEditVisitInfo
                ? <EditVisitInfoForm
                    visit={visita}
                    onCancel={() => setIsEditVisitInfo(false)}/>
                : <VisitDetailsInfo
                    visita={visita}
                    onEditButton={() => setIsEditVisitInfo(true)}/>
                }
            </div>

            <div className="flex gap-x-10 py-2">
                <div>
                    <label className="text-sm font-semibold">Estatus de la visita</label>
                    {visita.terminado 
                    ?
                    <div className="border-2 border-red-400 bg-red-100 w-fit px-3 rounded-full">
                        <p className="h-[26px] font-semibold">{visita.terminado ? "Terminada" : "Abierta"}</p>
                    </div>
                    :
                    <div className="border-2 border-green-400 bg-green-100 w-fit px-3 rounded-full">
                        <p className="h-[26px] font-semibold">{visita.terminado ? "Terminada" : "Abierta"}</p>
                    </div>
                    }
                </div>

                <div>
                    <label className="text-sm font-semibold">Total de intenciones vendidas</label>
                    <p
                        className="
                            w-full h-[26px] my-1 px-2  text-center
                            font-semibold text-gray-600 text-sm" >
                        {visita.intencionesVendidas} intenciones
                    </p>
                </div>
            </div>

            {visita.terminado
            ?
            <IntencionesVendidas 
                intenciones={visita.vendedores ?? []} />
            :
            <>
            {isAddVendedores
            ?
            <AddVendedoresToVisita 
                setVendedoresAgregados={setVendedoresAgregados}
                setIsAddVendedores={setIsAddVendedores}
                vendedoresAgregados={vendedoresAgregados}
                visitaId={visitaId}
            />
            :
            <VendedoresAsignados
                visitaId={visitaId}
                setIsAddVendedores={setIsAddVendedores} />
            }
            </>
            }

            {!isAddVendedores && (
            <div className="flex gap-x-2 justify-center pt-3">
                {(!visita.terminado && !disableFinishButton) && (
                <SaveButton 
                    text="Terminar visita"
                    onClick={onFinish}
                    type="button"/>
                )}

                <CancelButton
                    text="Regresar"
                    onClick={onCancel}/>
            </div>
            )}
        </div>
    );
}